import React from "react";

export type IDamageIndicatorIconProps = {};

const DamageIndicatorIcon: React.FC<IDamageIndicatorIconProps> = ({}) => {
 return (
  <svg
   xmlns="http://www.w3.org/2000/svg"
   width={24.555}
   height={40.807}
   viewBox="0 0 24.555 40.807"
  >
   <path
    data-name="Path 3307"
    d="M24.163 21.931a2.254 2.254 0 00-1.544-1.287 3.319 3.319 0 00-2.772.805 11.736 11.736 0 01-4.882 2.025q-2.49.382-2.681.382t-2.681-.382a11.859 11.859 0 01-4.9-2.025 3.319 3.319 0 00-2.77-.805 2.2 2.2 0 00-1.527 1.287 2.182 2.182 0 00-.054 2.449 9.724 9.724 0 002.731 2.25 12.582 12.582 0 003.731 1.535 21.888 21.888 0 003.553.573l-7.77 7.752a2.378 2.378 0 00-.764 1.684 2.324 2.324 0 00.764 1.67l.3.3a2.2 2.2 0 001.619.664 2.612 2.612 0 001.736-.665l6.026-6.043 6.124 6.043a2.552 2.552 0 001.685.664 2.491 2.491 0 001.665-.664l.3-.3a2.491 2.491 0 00.666-1.669 2.552 2.552 0 00-.666-1.684l-7.77-7.753a20.828 20.828 0 003.5-.573 12.663 12.663 0 003.686-1.536 9.724 9.724 0 002.731-2.25 2.2 2.2 0 00-.036-2.447zM12.276 5.18a5.232 5.232 0 013.644 1.519 4.876 4.876 0 011.432 3.594 4.876 4.876 0 01-1.436 3.594 4.937 4.937 0 01-3.644 1.436 4.937 4.937 0 01-3.64-1.436 4.876 4.876 0 01-1.436-3.594 4.876 4.876 0 011.436-3.594 5.232 5.232 0 013.644-1.519zm0 15.506a10.679 10.679 0 007.33-3.055 10.142 10.142 0 003.013-7.288 10.3 10.3 0 00-3.013-7.321 10.271 10.271 0 00-7.33-3.021 10.28 10.28 0 00-7.324 3.021 10.28 10.28 0 00-3.019 7.321 10.126 10.126 0 003.019 7.288 10.691 10.691 0 007.324 3.055z"
   />
  </svg>
 );
};

export { DamageIndicatorIcon };
